import PrimaryWrapper from './PrimaryWrapper';

export default PrimaryWrapper;
